import React, {Component} from 'react';
import {Button, Container, Menu, Segment} from "semantic-ui-react";
import {getLocalization} from "../utils/localization";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import LanguageSelector from "./languageSelector";
import LimitationsExclusionsModal from "./limitationsExclusionsModal";
import {BREAKPOINTS, getArrayByLanguage, isNationwide, isRenaissance} from "../utils/common";
import {STRATEGIC_PARTNER} from "../constants/strategicPartners";
import {CustomGrid, Responsive} from './custom-common';


const mapStateToProps = ({user, initialData: { disclaimers }}, ownProps) => ({
    ...ownProps,
    lang: user.lang,
    disclaimers
});

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            renderLimitationsAndExclusionsModal: false,
            countdown: null,
        }
        this.autoAdvanceTimer = null;
    }

    componentDidMount() {
        const {autoAdvanceSeconds, disabled, loading} = this.props;
        if (autoAdvanceSeconds && isRenaissance() && !disabled && !loading) {
            this.startAutoAdvance(autoAdvanceSeconds);
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.pauseAutoAdvance && this.props.pauseAutoAdvance) {
            this.clearAutoAdvance();
            this.setState({countdown: null});
        }
    }

    componentWillUnmount() {
        this.clearAutoAdvance();
    }

    startAutoAdvance = (seconds) => {
        this.setState({countdown: seconds});
        this.autoAdvanceTimer = setInterval(() => {
            const next = this.state.countdown - 1;
            if (next <= 0) {
                this.setState({countdown: 0});
                this.handleAdvance();
            } else {
                this.setState({countdown: next});
            }
        }, 1000);
    }

    clearAutoAdvance = () => {
        if (this.autoAdvanceTimer) {
            clearInterval(this.autoAdvanceTimer);
            this.autoAdvanceTimer = null;
        }
    }

    handleAdvance = () => {
        this.clearAutoAdvance();
        const {onClickCallback} = this.props;
        if (onClickCallback) {
            onClickCallback();
        }
    }

    closeModal = () => {
        this.setState({renderLimitationsAndExclusionsModal: false})
    }

    footerMenuItems = () => {
        const {lang, hideLimitationsAndExclusions} = this.props;
        const localization = getLocalization(lang);
        const strings = localization.limitationsAndExclusions;
        return (
                <>
                    {!hideLimitationsAndExclusions &&
                        <Menu.Item  onClick={() => this.setState({renderLimitationsAndExclusionsModal: true})}>
                            {strings.title}
                        </Menu.Item>
                    }
                    <Menu.Item as="a" href={STRATEGIC_PARTNER.LEGAL.TERMS} target="_blank">
                        {strings.terms}
                    </Menu.Item>
                    <Menu.Item as="a" href={STRATEGIC_PARTNER.LEGAL.PRIVACY} target="_blank">
                        {strings.privacy}
                    </Menu.Item>
                    <LanguageSelector/>
                </>
        )
    }

    render() {
        const {buttonText, showTopFooter, link, showCenterData, loading, disabled, lang, disclaimers} = this.props;
        const {countdown} = this.state;
        const localization = getLocalization(lang);
        const strings = localization.limitationsAndExclusions;
        const filteredDisclaimers = getArrayByLanguage(disclaimers, lang);
        const carrierDisclaimers = filteredDisclaimers[filteredDisclaimers.length - 1].title?.split('\n');
        return (
            <div className={`footer nonprintable ${!showTopFooter && "whiteFooter"}
            ${isNationwide() && 'stickyFooter'}`}>
                {this.state.renderLimitationsAndExclusionsModal && <LimitationsExclusionsModal strings={strings} renderModal={this.state.renderLimitationsAndExclusionsModal} closeModal={this.closeModal}/>}
                {showTopFooter &&
                    <div className={"buttonContainer"}>
                        <Container>
                            <CustomGrid columns={3} verticalAlign={'middle'}>
                                <CustomGrid.Column mobile={4} tablet={5} computer={5}/>
                                <CustomGrid.Column mobile={4} tablet={2} computer={2}>
                                    <Button primary loading={!!loading} disabled={!!disabled || loading}
                                            onClick={this.handleAdvance}>
                                        {countdown !== null ? `${buttonText} (${countdown}s)` : buttonText}
                                    </Button>
                                </CustomGrid.Column>
                                <CustomGrid.Column mobile={4} tablet={5} computer={5} textAlign={'left'}>
                                    {!!link && link}
                                </CustomGrid.Column>
                            </CustomGrid>
                        </Container>
                    </div>
                }
                {isNationwide() ?
                    <>
                    <Responsive minWidth={BREAKPOINTS.DESKTOP}>
                        <Container fluid className={'footerContainer'}>
                            <CustomGrid columns={'equal'}>
                                <CustomGrid.Column>
                                    <Menu text>
                                        <Menu.Item style={{paddingLeft:0}}>
                                            {strings.copyright}
                                        </Menu.Item>
                                    </Menu>
                                </CustomGrid.Column>
                                <CustomGrid.Column>
                                    <Menu text className={'termsPrivacy'}>
                                        <Menu.Menu position="right" >
                                            {this.footerMenuItems()}
                                        </Menu.Menu>
                                    </Menu>
                                </CustomGrid.Column>
                            </CustomGrid>
                            { showCenterData &&
                                <CustomGrid.Row>
                                    { carrierDisclaimers?.map((paragraph, index) =>
                                        (<p key={index} className={'carrierDisclaimers'}>{paragraph}</p>))}
                                </CustomGrid.Row>
                            }
                        </Container>
                    </Responsive>
                    <Responsive maxWidth={BREAKPOINTS.DESKTOP - 1}>
                        <Segment basic className={'footerCopyRight'}>
                            <p >{strings.copyright}</p>
                            { showCenterData &&
                                <CustomGrid.Row>
                                    { carrierDisclaimers?.map((paragraph, index) =>
                                        (<p key={index}>{paragraph}</p>))}
                                </CustomGrid.Row>
                            }
                            <Menu text compact className={'termsPrivacy'}>
                                <Menu.Menu position="center" >
                                    {this.footerMenuItems()}
                                </Menu.Menu>
                            </Menu>
                        </Segment>
                    </Responsive>
                    </>
                  :
                    <Container fluid className={'footerContainer'}>
                        <CustomGrid columns={'equal'}>
                            <CustomGrid.Column>
                                <Menu text>
                                    <Menu.Item style={{paddingLeft:0}}>
                                        {strings.copyright}
                                    </Menu.Item>
                                </Menu>
                            </CustomGrid.Column>
                            <CustomGrid.Column>
                                <Menu text className={'termsPrivacy'}>
                                    <Menu.Menu position="right" >
                                        {this.footerMenuItems()}
                                    </Menu.Menu>
                                </Menu>
                            </CustomGrid.Column>
                        </CustomGrid>
                        { showCenterData &&
                            <CustomGrid.Row>
                                { carrierDisclaimers?.map((paragraph, index) =>
                                    (<p key={index} className={'carrierDisclaimers'}>{paragraph}</p>))}
                            </CustomGrid.Row>
                        }
                    </Container>
                }
            </div>
        )
    }
}

export default withRouter(connect(mapStateToProps)(Footer));
